import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import { useState } from 'react';

import { NavToggle } from '~components/Headers/NavToggle/NavToggle';
import { ThemesNames } from '~types/Theme.types';

import type { HeaderDropdownProps } from '../HeaderDropdown.types';
import styles from './HeaderDropdownDesktop.module.scss';

export function HeaderDropdownDesktop({
  title,
  items,
  leftPosition = false,
  className,
}: HeaderDropdownProps) {
  const [open, setOpen] = useState<boolean>(false);
  const toggleActiveItem = () => {
    return setOpen((prevState) => !prevState);
  };

  return (
    <div
      className={classNames(styles.dropdownWrapper, className)}
      data-testid="header-dropdown"
    >
      <NavToggle
        active={open}
        setActive={toggleActiveItem}
        mod={ThemesNames.White}
      >
        <Typography
          tagName={TypographySizes.p}
          mods={[TypographyMods.captionM]}
          className={styles.button}
          data-testid="header-dropdown-title"
        >
          {title}
        </Typography>
      </NavToggle>
      <div
        className={classNames(styles.dropdownHover, {
          [styles.leftPosition]: leftPosition,
          [styles.active]: open,
        })}
      >
        <div
          className={classNames(styles.dropdown, {
            [styles.leftPosition]: leftPosition,
          })}
          data-testid="header-dropdown-menu"
        >
          <div
            className={classNames(styles.dropdownItems, {
              [styles.oneColumn]: items.length === 1,
            })}
          >
            {items.map((column) => (
              <div className={styles.column} key={column.id}>
                {column.title && (
                  <Typography mods={[TypographyMods.captionMAlt]}>
                    {column.title}
                  </Typography>
                )}

                <ul key={column.id} className={styles.dropdownColumn}>
                  {column.dropdown &&
                    column.dropdown.map((item) => {
                      return (
                        <li key={item.id}>
                          <a
                            href={item.link?.href}
                            className={styles.dropdownItem}
                            data-testid="header-dropdown-item"
                          >
                            <div>
                              <Typography
                                className={styles.dropdownItemTitle}
                                tagName={TypographySizes.p}
                                mods={[TypographyMods.captionMAlt]}
                              >
                                {item.title}
                              </Typography>
                              {item.text && (
                                <Typography
                                  tagName={TypographySizes.p}
                                  mods={[TypographyMods.captionM]}
                                  className={styles.subtitle}
                                >
                                  {item.text}
                                </Typography>
                              )}
                            </div>
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
